<section id="wrapper" class="error-page">
  <div class="jumbotron">
    <h1 class="display-4">401 Acceso no autorizado</h1>
    <hr class="my-4">
    <h4>Usuario sin roles de aplicación asignados.</h4>
    <p>Este usuario no puede acceder a la pagina solicitada, ya que no posee los roles de seguridad necesarios para el acceso a la misma.</p>
    <p class="lead">
      <a class="btn btn-primary btn-lg" href="index.html" role="button">Volver al inicio</a>
    </p>
  </div>





  </section>
